module.exports = __webpack_public_path__ + "static/media/filter-empty-light.cd432bf9.svg";